module.exports = __webpack_public_path__ + "img/wide.e329e3b2.jpg";